import React, {Component} from "react";
import Checkbox from "./Checkbox";
import SAInfoBubble from "../../../../components/common/confirmation/SAInfoBubble";
import PriceTag from '../../../../components/common/pricetag/PriceTag';
import {durationToString} from "../../../../services/DurationUtil";

class CheckboxServiceItem extends Component {

  constructor(props) {
    super(props)
    this.state = {
      checked: props.checked,
    }
  }

  onChange = (value, item) => {
    this.props.onChange(value, item);
    this.setState({checked: value});
  }

  render() {
    const {item, ...rest} = this.props;

    return <React.Fragment>
      <Checkbox
        {...rest}
        id={item.name}
        onChange={value => this.onChange(value, item)}
        checked={this.state.checked}>
        <span>{item.title}</span>
        <span style={{float: 'right'}}>
          <span className={'mr-2'}>
           <PriceTag price={item.price}/>
          </span>
          {item.duration &&
            <span className={'mr-2'}>
              {durationToString(item.duration)}
            </span>
          }
          {item.moreInfo &&
            <SAInfoBubble content={item.moreInfo}/>
          }
        </span>
        {item.description &&
          <div style={{paddingLeft: '3rem', fontWeight: 'normal'}}>
            {item.description}
          </div>
        }
      </Checkbox>
    </React.Fragment>

  }
}


export default CheckboxServiceItem;
